import { AgentScoringRuleAgentToScoreEnum } from "@genesys/cloud-frontend/models";

/** Allowed sampling percentage bounds (inclusive). */
export const SAMPLING_PERCENTAGE_MIN = 0.01;
export const SAMPLING_PERCENTAGE_MAX = 100;
/** Maximum number of decimal places allowed for a sampling percentage. */
export const SAMPLING_PERCENTAGE_DECIMALS = 2;

/**
 * Default radio selection when creating a new rule.
 */
export const DEFAULT_AGENT_TO_SCORE_FOR_NEW_RULE =
    AgentScoringRuleAgentToScoreEnum.Each;

/**
 * Backfill when an existing rule has no `agentToScore` — historical API default
 * for rules that predate the field.
 */
export const DEFAULT_AGENT_TO_SCORE_WHEN_MISSING =
    AgentScoringRuleAgentToScoreEnum.Last;

export function isSamplingPercentageValid(
    percentage: number | null | undefined
): percentage is number {
    return (
        percentage != null &&
        !Number.isNaN(percentage) &&
        percentage >= SAMPLING_PERCENTAGE_MIN &&
        percentage <= SAMPLING_PERCENTAGE_MAX &&
        // Reject values with more precision than 2 decimal places.
        Number(percentage.toFixed(SAMPLING_PERCENTAGE_DECIMALS)) === percentage
    );
}

/**
 * Sorts rules so enabled ones appear first; otherwise preserves order.
 * Returns a new array (does not mutate the input).
 */
export function sortRulesByStatus<T extends { enabled?: boolean }>(
    rules: readonly T[]
): T[] {
    return [...rules].sort((a, b) => {
        if (a.enabled === b.enabled) return 0;
        return a.enabled ? -1 : 1;
    });
}
